import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=4ad20b51&scoped=true"
import script from "./parts.vue?vue&type=script&lang=ts"
export * from "./parts.vue?vue&type=script&lang=ts"
import style0 from "./parts.vue?vue&type=style&index=0&id=4ad20b51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad20b51",
  null
  
)

export default component.exports